var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowsMinimize(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7501 5.66663C13.5325 5.66663 14.1667 6.30089 14.1667 7.08329V12.75C14.1667 13.5324 13.5325 14.1666 12.7501 14.1666H7.08341C6.30101 14.1666 5.66675 13.5324 5.66675 12.75C5.66675 11.9676 6.30101 11.3333 7.08341 11.3333H11.3334V7.08329C11.3334 6.30089 11.9677 5.66663 12.7501 5.66663Z",
    fill: "#008187"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.24818 3.24831C3.80143 2.69506 4.69841 2.69506 5.25165 3.24831L13.7517 11.7483C14.3049 12.3015 14.3049 13.1985 13.7517 13.7518C13.1984 14.305 12.3014 14.305 11.7482 13.7518L3.24818 5.25178C2.69494 4.69853 2.69494 3.80155 3.24818 3.24831Z",
    fill: "#008187"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66675 21.25C5.66675 20.4676 6.30101 19.8334 7.08341 19.8334H12.7501C13.5325 19.8334 14.1667 20.4676 14.1667 21.25V26.9167C14.1667 27.6991 13.5325 28.3334 12.7501 28.3334C11.9677 28.3334 11.3334 27.6991 11.3334 26.9167V22.6667H7.08341C6.30101 22.6667 5.66675 22.0324 5.66675 21.25Z",
    fill: "#008187"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7517 20.2483C14.3049 20.8015 14.3049 21.6985 13.7517 22.2518L5.25165 30.7518C4.69841 31.305 3.80143 31.305 3.24818 30.7518C2.69494 30.1985 2.69494 29.3015 3.24818 28.7483L11.7482 20.2483C12.3014 19.6951 13.1984 19.6951 13.7517 20.2483Z",
    fill: "#008187"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2499 5.66663C22.0323 5.66663 22.6666 6.30089 22.6666 7.08329V11.3333H26.9166C27.699 11.3333 28.3333 11.9676 28.3333 12.75C28.3333 13.5324 27.699 14.1666 26.9166 14.1666H21.2499C20.4675 14.1666 19.8333 13.5324 19.8333 12.75V7.08329C19.8333 6.30089 20.4675 5.66663 21.2499 5.66663Z",
    fill: "#008187"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7517 3.24831C31.3049 3.80155 31.3049 4.69853 30.7517 5.25178L22.2517 13.7518C21.6984 14.305 20.8014 14.305 20.2482 13.7518C19.6949 13.1985 19.6949 12.3015 20.2482 11.7483L28.7482 3.24831C29.3014 2.69506 30.1984 2.69506 30.7517 3.24831Z",
    fill: "#008187"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8333 21.25C19.8333 20.4676 20.4675 19.8334 21.2499 19.8334H26.9166C27.699 19.8334 28.3333 20.4676 28.3333 21.25C28.3333 22.0324 27.699 22.6667 26.9166 22.6667H22.6666V26.9167C22.6666 27.6991 22.0323 28.3334 21.2499 28.3334C20.4675 28.3334 19.8333 27.6991 19.8333 26.9167V21.25Z",
    fill: "#008187"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2482 20.2483C20.8014 19.6951 21.6984 19.6951 22.2517 20.2483L30.7517 28.7483C31.3049 29.3015 31.3049 30.1985 30.7517 30.7518C30.1984 31.305 29.3014 31.305 28.7482 30.7518L20.2482 22.2518C19.6949 21.6985 19.6949 20.8015 20.2482 20.2483Z",
    fill: "#008187"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsMinimize);
export default __webpack_public_path__ + "static/media/arrows-minimize.a7bd302291d1195ff9aca19071a33754.svg";
export { ForwardRef as ReactComponent };